function hexToRgb(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
        throw new Error(`invalid hex color ${hex} provided`);
    }
    return [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
    ];
}

function hexToRgbaString(hex: string, opacity?: number) {
    const opacityStr = opacity ? `,${opacity}` : '';
    return `rgba(${ColorHelper.hexToRgb(hex).join(',')}${opacityStr})`;
}

function _componentToHex(c) {
    return c.toString(16).padStart(2, '0');
}

function rgbToHex(r, g, b) {
    return '#' + _componentToHex(r) + _componentToHex(g) + _componentToHex(b);
}

export const ColorHelper = {
    hexToRgb,
    hexToRgbaString,
    rgbToHex,
};
